import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  public server = environment.APIEndpoint;
  public guestToken = localStorage.getItem('guestUserToken');
  public isLoggedIn: boolean = false;
  constructor(private http: HttpClient,private commonFunction: CommonFunctions,
    private storageService:StorageService,
    private apiHeader: ApiHeaderService) {
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
  }
  public urls: any = {
    unSecSearchAutoSuggestion: this.server + 'api/unsec/es/v1/suggestion',
    secSearchAutoSuggestion: this.server + 'api/es/v1/suggestion',
    secRecentSearch:this.server + 'api/user/global/search/key/v1/list',
    secMenuSearch:this.server+'api/es/v1/search',
    unSecMenuSearch:this.server+'api/unsec/es/v1/search',
    unSecTopMenuCat:this.server+'api/unsec/menu/top/category/v1/list',
    secTopMenuCat:this.server+'api/menu/top/category/v1/list'
  };
  public deviceMetaInfo = {
    "appVersion": "",
    "deviceCountry": "India",
    "deviceCity": "",
    "deviceId": localStorage.getItem("deviceId"),
    "deviceModel": "",
    "platform": "WEB",
    "deviceOSVersion": ""
  };
  public unsecureHeaderData = {
    'Accept-Language': 'EN',
    'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo),
    'GuestToken':this.guestToken
  }
  public secHeaderData = {
    'Accept-Language': 'EN',
    'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
    'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
  };
  public getAutoSuggestion(requestParam:any){
    let reqParam=this.generateRequestParam(requestParam);
    let login = this.commonFunction.verifyLoggedInUser();
    if(login){
    return  this.getSecAutoSuggestion(reqParam);
    }else{
     return this.getUnSecAutoSuggestion(reqParam);
    }
  }
  private generateRequestParam(requestParam){
    let reqString="?"
    requestParam.forEach(element => {
      reqString=reqString+element.name+'='+element.value+'&';
    });
    return reqString;
  }
  public getSecAutoSuggestion(reqParam:any){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.secSearchAutoSuggestion+reqParam, { headers: secHeaders });
  }
  public getUnSecAutoSuggestion(reqParam:any): Observable<any>{
    let unsecureHeaders =  this.apiHeader.getUnSecureHeader();
    return this.http.get(this.urls.unSecSearchAutoSuggestion+reqParam, { headers: unsecureHeaders });
  }
  public getRecentSearchData(searchType:string):Observable<any>{
    let secHeaders = this.apiHeader.getSecureHeader();
    secHeaders['searchType']=searchType;
    return this.http.post(this.urls.secRecentSearch,null, { headers: secHeaders });
  }
  public getSearchMenu(requestParam:any){
    let reqParam=this.generateRequestParam(requestParam);
    let login = this.commonFunction.verifyLoggedInUser();
    if(login){
    return  this.getSecMenu(reqParam);
    }else{
     return this.getUnSecMenu(reqParam);
    }
  }
  public getSecMenu(reqParam:any){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.secMenuSearch+reqParam, { headers: secHeaders });
  }
  public getUnSecMenu(reqParam:any){
    let unsecureHeaders =  this.apiHeader.getUnSecureHeader();
    return this.http.get(this.urls.unSecMenuSearch+reqParam, { headers: unsecureHeaders });
  }
  public getTopCatList(requestParam:any){
    let reqParam=this.generateRequestParam(requestParam);
    let login = this.commonFunction.verifyLoggedInUser();
    if(login){
    return  this.getSecTopMenuCat(reqParam);
    }else{
     return this.getUnSecTopMenuCat(reqParam);
    }
  }
  public getSecTopMenuCat(reqParam:any){
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.get(this.urls.secTopMenuCat+reqParam, { headers: secHeaders });
  }
  public getUnSecTopMenuCat(reqParam:any){
    let unsecureHeaders =  this.apiHeader.getUnSecureHeader();
    return this.http.get(this.urls.unSecTopMenuCat+reqParam, { headers: unsecureHeaders });
  }
}
